import type { PayloadAction } from '@reduxjs/toolkit';
import type { EditorState } from './state';
import { withBackgroundKey } from './screenBackground';

/**
 * Решение владельца №3 (2026-10-08, повтор эталона Slimkit): тон картинки фона
 * экрана. `'auto'` и `undefined` — ключ ФИЗИЧЕСКИ удаляется (прежнее
 * поведение — вуаль и светлый текст); хранится только `'light'`.
 *
 * Тело действия `setScreenBackgroundImageTone` живёт здесь, а не в
 * editorSlice.ts: фасад держит храповик длины (WEB-2552, FACADE_MAX_LINES в
 * store/__tests__/editorSlice.test.ts), и новые действия экрана приходят в
 * него одной строкой `withHistoryPayload(<тело отсюда>)`. Имя действия
 * прежнее — `editor/setScreenBackgroundImageTone`.
 */
export interface ScreenImageTonePayload {
  screenId: string;
  imageTone?: 'auto' | 'light';
}

export function setScreenImageToneReducer(
  state: EditorState,
  action: PayloadAction<ScreenImageTonePayload>,
): EditorState {
  const { screenId, imageTone } = action.payload;
  return {
    ...state,
    content: state.content.map((s) =>
      s.id === screenId
        ? {
            ...s,
            background: withBackgroundKey(
              s.background,
              'imageTone',
              imageTone === 'light' ? 'light' : undefined,
            ),
          }
        : s,
    ),
    isDirty: true,
  };
}
